import React, { useState, useContext, useEffect } from 'react';
import { Range } from 'react-range';
import RadioConfigContext from '../../context/RadioConfigContext/RadioConfigContext';
import SelectRadio from './SelectRadio';
import BeatLoader from "react-spinners/BeatLoader";
import { RadioName, VolumePercentBox, LoaderBox, RangeBox, MuteButtonBox, MuteButton, RadioPlayStopButton, RadioOptionsBox, RadioBox, RadioInner, RadioInfo, RadioInfoImage, RadioPanel, RadioPanelPlayStopButton, RadioPanelVolumeBox } from './Radio.css';

const Radio = () => {
  const { radioConfig, setRadioConfig } = useContext(RadioConfigContext);
  const [volumeState, setVolumeState] = useState(1);
  const [playing, setPlaying] = useState(false);

  const listener = (event: { data: string}) => {
    if (event.data === 'loaded') {
      setPlaying(true);
      setRadioConfig({...radioConfig, loading: false});
    }
    if (event.data === 'resumed') {
      setPlaying(true);
    }
  };

  useEffect(() => {
    window.addEventListener("message", listener);
    return () => {
      window.removeEventListener("message", listener);
    }
  }, [radioConfig]);

  const handleChangeVolume = (values: number[]) => {
    setVolumeState(values[0]);
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage('setVolume[#]' + values[0]);
    }

    // setRadioConfig({...radioConfig, volume});
  };

  const handlePlayStop = () => {
    setPlaying(!playing);
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage('changeState[#]' + (!playing).toString());
    }
  };

  const handleMuteButton = () => {
    if (volumeState > 0) {
      handleChangeVolume([0]);
    } else {
      handleChangeVolume([0.5]);
    }
  }

  return (
    <RadioBox>
      <RadioInner>
        {!radioConfig.url && <SelectRadio />}
        <RadioInfo>
          <RadioInfoImage bg={radioConfig.thumb}></RadioInfoImage>
        </RadioInfo>
        <RadioPanel>
          <RadioName>{radioConfig.name === '' ? 'SELECT RADIO' : radioConfig.name}</RadioName>
          <RadioOptionsBox>
            <RadioPanelPlayStopButton>
              <RadioPlayStopButton onClick={handlePlayStop}>
                <i style={{fontSize: 12}} className={`fa fa-${playing ? 'stop' : 'play'}`} />
              </RadioPlayStopButton>
              <LoaderBox>
                {radioConfig.loading ? <BeatLoader color="#999" size={10} loading={true} />
                :
                  <div style={{height: 30, width: 20, position: 'relative'}}>
                    <div className={`bar ${!playing && 'stopped'}`} />
                    <div className={`bar ${!playing && 'stopped'}`} />
                    <div className={`bar ${!playing && 'stopped'}`} />
                    <div className={`bar ${!playing && 'stopped'}`} />
                    <div className={`bar ${!playing && 'stopped'}`} />
                  </div>
                }
              </LoaderBox>
            </RadioPanelPlayStopButton>
            <RadioPanelVolumeBox>
              <MuteButtonBox>
                <MuteButton onClick={handleMuteButton}>
                  <i className={`fa fa-volume-${volumeState === 0 ? 'mute' : 'up'}`} />
                </MuteButton>
              </MuteButtonBox>
              <RangeBox>
                <Range step={0.01} min={0} max={1} onChange={handleChangeVolume} values={[volumeState]}
                  renderTrack={({ props, children }) => (
                    <div
                      {...props}
                      style={{
                        ...props.style,
                        height: 4,
                        width: '100%',
                        backgroundColor: '#ccc'
                      }}
                    >
                      {children}
                    </div>
                  )}
                  renderThumb={({ props }) => (
                    <div
                      {...props}
                      style={{
                        ...props.style,
                        height: 16,
                        width: 16,
                        borderRadius: 8,
                        backgroundColor: '#999'
                      }}
                    />
                  )}
                />
              </RangeBox>
              <VolumePercentBox>
                {Math.round(volumeState * 100)}%
              </VolumePercentBox>
            </RadioPanelVolumeBox>
          </RadioOptionsBox>
        </RadioPanel>
      </RadioInner>
    </RadioBox>
  );
};

export default Radio;